import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import withState from "recompose/withState";
import withProps from "recompose/withProps";
import get from "lodash/get";
import range from "lodash/range";
import CharacterNav from "./CharacterNav";
import withMedia from "../../../hocs/withMediaQueries";

const enhance = compose(
  withMedia,
  withState("isPickerOpen", "setIsOpen", false),
  withHandlers({
    onClickLetter: (props) => () => {
      props.setIsOpen(false);
      props.setActivePage(props.id);
      props.setActiveNav(props.characterIndex);
    },
    onClickChange: (props) => () => props.setIsOpen(true),
    onClickCancel: (props) => () => props.setIsOpen(false),
  }),
  withProps((props) => ({
    isModal: props.media.fabletDown,
    isChangeable:
      props.isActive &&
      props.characters.length > 1 &&
      props.characters.length >
        props.values.character_selection.filter(
          (c) => c.letter === props.letter
        ).length,
    selectedCharacter:
      props.characters.find(
        (c) =>
          c.character ===
          get(
            props,
            [
              "values",
              "character_selection",
              props.characterIndex,
              "character",
            ],
            props.defaultCharacter
          )
      ) || props.characters[0],
    isPageActive: range(props.activePage, props.activePage - 4).includes(
      props.id
    ),
  }))
);

export default enhance(CharacterNav);
